/* Lulevi — recently viewed products (localStorage + Section Rendering API) */
(function () {
  var KEY = 'lulevi:recently-viewed';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {
      /* storage unavailable — ignore */
    }
  }

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      var current = this.dataset.productId ? String(this.dataset.productId) : '';
      var list = read();

      if (current) {
        list = list.filter(function (id) {
          return id !== current;
        });
        list.unshift(current);
        write(list);
      }

      var ids = read().filter(function (id) {
        return id !== current;
      });
      var limit = parseInt(this.dataset.limit || '4', 10);
      ids = ids.slice(0, limit);

      if (!ids.length) return;
      // fetched once it is near the screen: inserted below the fold, it no longer shoves the page (CLS 0.15–0.30).
      // The element itself is [hidden] (display: none never intersects), so watch its section wrapper (zero height, still laid out).
      if (!('IntersectionObserver' in window)) return this.load(ids);
      var self = this;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        self.load(ids);
      }, { rootMargin: '600px 0px' });
      io.observe(this.parentElement || this);
    }

    load(ids) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var q = ids
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ');
      var url =
        root +
        'search?type=product&options[unavailable_products]=last&q=' +
        encodeURIComponent(q) +
        '&section_id=' +
        this.dataset.sectionId;

      var self = this;
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('bad response');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = Array.prototype.slice.call(doc.querySelectorAll('li.grid__item'));
          if (!items.length) return;

          var grid = self.querySelector('[data-lulevi-rv-grid]');
          if (!grid) return;

          // Preserve recency order (search may reorder).
          var byHandle = {};
          items.forEach(function (li) {
            var link = li.querySelector('a[href*="/products/"]');
            var handle = link ? link.getAttribute('href').split('/products/')[1].split('?')[0] : '';
            byHandle[handle] = li;
          });

          items.forEach(function (li) {
            grid.appendChild(li);
          });

          self.hidden = false;
        })
        .catch(function () {
          /* fail silently — recently viewed is non-critical */
        });
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
